import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  user: null,
  users: [],
  roles: [],
  pageSize: storage.session.getItem(types.USER_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.USER_DAYS) || 0,
  searchTerm: storage.session.getItem(types.USER_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.USER_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.USER_ORDER_BY) || 'Id',
  filterBy: parseInt(storage.local.getItem(types.USER_FILTER_BY)) || 9999,
  filterOptions: [],
  isUserChecked: false,
  firmName: null
})



// WEBPACK FOOTER //
// ./src/store/modules/users/state.js